import React from 'react';
import { Link } from 'react-router-dom';

import { routes, socialLinks } from '../../constants';

import logo from '../../images/logo-white.png';

function Layout() {
  return (
    <header className="header">
      <div className="header-top">
        <div className="container">
          <div className="row justify-content-between d-flex">
            <div className="col-xl-6 col-lg-6 d-flex align-items-center">
              <div className="support-bar">
                {/* <ul>
                  <li>
                    <span className="icon">
                      <i className="fas fa-envelope"></i>
                    </span>
                    {companyEmail}
                  </li>
                  <li>
                    <span className="icon">
                      <i className="fas fa-phone"></i>
                    </span>
                    {companyPhone}
                  </li>
                </ul> */}
              </div>
            </div>
            <div className="col-xl-2 col-lg-2">
              <div className="social">
                <a href={socialLinks.facebook}>
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href={socialLinks.instagram}>
                  <i className="fab fa-instagram"></i>
                </a>
                {/* <a href="index.html#">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="index.html#">
                  <i className="fab fa-dribbble"></i>
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="header-bottom">
        <div className="container">
          <div className="row d-flex">
            <div className="col-xl-2 col-lg-2 col-12 d-block d-xl-flex d-lg-flex align-items-center">
              <div className="mobile-special">
                <div className="row d-flex">
                  <div className="col-6 col-xl-12 col-lg-12 d-flex align-items-center">
                    <div className="logo">
                      <a href={routes.external.home}>
                        <img src={logo} alt="BROWNCON" />
                      </a>
                    </div>
                  </div>
                  <div className="col-6 d-block d-xl-none d-lg-none">
                    <button
                      className="navbar-toggler"
                      type="button"
                      data-toggle="collapse"
                      data-target="#navbarSupportedContent"
                      aria-controls="navbarSupportedContent"
                      aria-expanded="false"
                      aria-label="Toggle navigation"
                    >
                      <span className="navbar-toggler-icon">
                        <i className="fas fa-bars"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-8 col-lg-8">
              <div className="mainmenu">
                <nav className="navbar navbar-expand-lg">
                  <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav mr-auto justify-content-center">
                      <li className="nav-item active">
                        <a className="nav-link" href={routes.external.home}>
                          Home <span className="sr-only">(current)</span>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href={routes.external.about}>
                          About
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href={routes.external.services}>
                          Our Services
                        </a>
                      </li>
                      {/* <li className="nav-item">
                        <Link className="nav-link" to={routes.faq}>
                          FAQ
                        </Link>
                      </li> */}
                      {/* <li className="nav-item">
                        <Link className="nav-link" to={routes.team}>
                          Team
                        </Link>
                      </li> */}
                      {/* <li className="nav-item dropdown">
                        <Link
                          className="nav-link dropdown-toggle"
                          to={routes.blog}
                          id="navbarDropdown"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Blog
                        </Link>
                        <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                          <Link className="dropdown-item" to={routes.blog}>
                            Blog
                          </Link>
                          <Link className="dropdown-item" to={routes.blogDetails}>
                            Blog Details
                          </Link>
                        </div>
                      </li> */}
                      <li className="nav-item">
                        <a className="nav-link" href={routes.external.contact}>
                          Contact Us
                        </a>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
            <div className="col-xl-2 col-lg-2 d-flex align-items-center">
              <div className="join-us">
                {/* <div className="col-xl-6 col-lg-6"> */}
                <Link to={routes.login}>Login</Link>
                {/* </div> */}
                {/* <div className="col-xl-6 col-lg-6">
                  <Link to={routes.join}>Sign Up</Link>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Layout;
